import { MutualForm } from './components'

export default function App () {
  return (
    <>
      <MutualForm />
    </>
  )
}
